import { useTranslation } from 'react-i18next';

import { CustomModal } from 'components/shared';

import styles from './NoSelectedStorageAlertModal.module.css';

type NoSelectedStorageAlertModalProps = {
   opened: boolean;
   isPersonalPickUpAddress?: boolean;
   onClose: () => void;
};

const NoSelectedStorageAlertModal = ({
   opened,
   isPersonalPickUpAddress,
   onClose,
}: NoSelectedStorageAlertModalProps) => {
   const { t } = useTranslation();

   return (
      <CustomModal
         opened={opened}
         onClose={onClose}
         innerTitle={
            isPersonalPickUpAddress
               ? t('noSelectedStorageAlertModal.personalPickupTitle')
               : t('noSelectedStorageAlertModal.deliveryTitle')
         }
         icon="ALERT_TRIANGLE"
         secondaryButtonProps={{
            text: t('common.close'),
            variant: 'outlined-danger',
            onClick: onClose,
         }}
         modalContentClassName={styles.modalContent}
      >
         <p className={styles.modalText}>
            {isPersonalPickUpAddress
               ? t('noSelectedStorageAlertModal.personalPickupMessage')
               : t('noSelectedStorageAlertModal.deliveryMessage')}
         </p>
      </CustomModal>
   );
};

export default NoSelectedStorageAlertModal;
